import React, { useState } from 'react';
import { Box, Paper, Tab, Tabs } from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import StorefrontIcon from '@mui/icons-material/Storefront';

import { AddonStore } from './AddonStore';
import { SubscriptionTab } from '../streamer-tabs/SubscriptionTab';
import { ConsolePageShell } from '../console/ConsolePageShell';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel({ children, value, index }: TabPanelProps) {
  if (value !== index) return null;
  return <Box sx={{ py: 3 }}>{children}</Box>;
}

export const PortalBilling: React.FC = () => {
  const [value, setValue] = useState(0);

  return (
    <Box sx={{ width: '100%' }}>
      <ConsolePageShell
        title="Billing"
        eyebrow="Channel Commerce"
        subtitle="Manage subscription status, invoices, payments, and service add-ons from one place."
      >
        <Paper
          square
          elevation={0}
          sx={{ borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'transparent' }}
        >
          <Tabs
            value={value}
            onChange={(_, next) => setValue(next)}
            aria-label="billing tabs"
            variant="scrollable"
            allowScrollButtonsMobile
            sx={{
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 700,
                fontSize: { xs: '0.8rem', sm: '0.9rem' },
                minHeight: { xs: 44, sm: 48 },
                borderRadius: 0,
                px: { xs: 1.25, sm: 2 },
              },
              '& .MuiTabs-indicator': { height: 2 },
              '& .MuiTabs-scrollButtons': {
                borderRadius: 0,
              },
            }}
          >
            <Tab icon={<ReceiptLongIcon />} iconPosition="start" label="Subscription & Billing" />
            <Tab icon={<StorefrontIcon />} iconPosition="start" label="Add-on Store" />
          </Tabs>
        </Paper>

        <TabPanel value={value} index={0}>
          <SubscriptionTab onOpenStore={() => setValue(1)} />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <AddonStore />
        </TabPanel>
      </ConsolePageShell>
    </Box>
  );
};
